import _ from 'lodash';

// Helpers de promoção (campanha de promoção) compartilhados entre a tela de
// Marketing (prévia) e a tela de Campanha de Promoção.
//
// Semântica de status do item promocional (item_catalogo):
//   ativa    → status === 2 && ativo === 1 && categoria da campanha ativa
//              (aprovada pela loja, visível no app)
//   novidade → status === 1 && ativo === 1 (disponibilizada, aguardando ativação da loja)
//
// `categoria_ativo` vem do backend (cc.ativo AS categoria_ativo em
// CampanhaPromocaoController.getItensByEstabelecimento). Quando a categoria da
// campanha está desativada, a promo não está no ar mesmo com status/ativo ok.

export function isAtivoPromo(p) {
  const catAtiva = p.categoria_ativo == null || Number(p.categoria_ativo) === 1;
  return Number(p.status) === 2 && Number(p.ativo) === 1 && catAtiva;
}

export function isNovidadePromo(p) {
  return Number(p.ativo) === 1 && Number(p.status) === 1;
}

// Agrupa promoções por campanha (campanha_promocao_id), no padrão de
// gruposVisiveis de CampanhaPromocao.vue. `itemPreview` é a primeira promoção
// NÃO ativa do grupo (priorizando novidade/aguardando aprovação quando houver)
// — usado na prévia da tela de Marketing (uma promoção por campanha).
export function agruparPromosPorCampanha(promos) {
  const grupos = _.groupBy(promos || [], p => p.campanha_promocao_id);
  return Object.keys(grupos)
    .map(campanhaId => {
      const itens = grupos[campanhaId];
      const ref = itens[0] || {};
      const ativas = itens.filter(isAtivoPromo);
      const naoAtivas = itens.filter(p => !isAtivoPromo(p));
      const itemPreview = naoAtivas.find(isNovidadePromo) || naoAtivas[0] || null;
      return {
        key: campanhaId,
        id: ref.campanha_promocao_id,
        nome: ref.campanha_nome,
        descricao: ref.campanha_descricao,
        imagem: ref.campanha_imagem,
        itens: itens,
        ativas: ativas,
        naoAtivas: naoAtivas,
        itemPreview: itemPreview,
      };
    })
    .filter(g => g.itens && g.itens.length)
    .sort((a, b) => {
      // Campanhas cuja prévia é uma novidade (pendente) vêm primeiro.
      const na = a.itemPreview && isNovidadePromo(a.itemPreview) ? 0 : 1;
      const nb = b.itemPreview && isNovidadePromo(b.itemPreview) ? 0 : 1;
      if (na !== nb) {
        return na - nb;
      }
      return String(a.nome || '').localeCompare(String(b.nome || ''));
    });
}

export default {
  isAtivoPromo,
  isNovidadePromo,
  agruparPromosPorCampanha,
};
